import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';


import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import { Row, Col, Card, Tabs, Tab, Spinner, Badge, Modal, InputGroup } from 'react-bootstrap'
import Carousel from 'react-bootstrap/Carousel';



import { auth, firestore } from '../../../Database/firebase';
// import { AuthContext } from '../../Old_Test/Auth';

import { Link, Navigate, useNavigate, useParams } from "react-router-dom";

import { FaHeart, FaTruck, FaFacebookMessenger, FaSketch, FaRegHeart, FaRegCommentAlt, FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { BsStarFill, BsStarHalf, BsStar, BsEye, BsBookmark, BsChatSquareQuote, BsSearch } from "react-icons/bs";
import { text } from '@fortawesome/fontawesome-svg-core';
import { FcFlashOn } from "react-icons/fc";

import "./../content.css";

const Category = () => {

    let { categoryName } = useParams();

    const [bookLists, setBookLists] = useState([]);
    const [currentCursor, setCurrentCursor] = useState("");
  
      useEffect(() => {
          const firsPageRef = firestore
              .collection("product")
              .where("publicStatus", "==", 1)
              .where("productCategory", "==", categoryName)
              .orderBy("productDate", "desc")
              
              .limit(8);
          firsPageRef.get().then((querySnapshot) => {
              let tempLists = [];
              querySnapshot.docs.forEach((doc) => {
                  if (doc.exists) {
  
                      const currentBook = {
  
                        id: doc.id,
                        productID: doc.data().productID,
                        merchantName: doc.data().merchantName,
                        productName: doc.data().productName,
                        productImage: doc.data().productImage,
                        productFullPrice: doc.data().productFullPrice,
                        productPrice: doc.data().productPrice, 
                        productTypeCategory: doc.data().productTypeCategory,
  
                        productRatingSum: doc.data().productRatingSum,
                        productRatingCount: doc.data().productRatingCount,

                        saleCount: doc.data().saleCount,

                        publicStatus: doc.data().publicStatus,
                       
  
                      };
                      tempLists = [...tempLists, currentBook];
                      
                  }
              });
  
  
              setBookLists((prv) => tempLists);
              const currentLenght = querySnapshot.docs.length;
              const currentCursorFromFirstPage = querySnapshot.docs[currentLenght - 1];
              setCurrentCursor(currentCursorFromFirstPage);
          })
      }, []);
  
      const onMoreBooks = () => {
          const nextPageRef = firestore
              .collection("product")
              .where("publicStatus", "==", 1)
              .where("productCategory", "==", categoryName)
              .orderBy("productDate", "desc")
              
              .limit(8);
          nextPageRef.get().then((querySnapshot) => {
              const currentLenght = querySnapshot.docs.length;
              if (!currentCursor) {
                  return;
              }
              const query = nextPageRef.startAfter(currentCursor);
              query.get().then((querySnapshot) => {
                  let tempNewArray = [];
                  querySnapshot.forEach((doc) => {
                      if (doc.exists) {
                          tempNewArray = [
                              ...tempNewArray,
                              {
                                id: doc.id,
                                productID: doc.data().productID,
                                merchantName: doc.data().merchantName,
                                productName: doc.data().productName,
                                productImage: doc.data().productImage,
                                productFullPrice: doc.data().productFullPrice,
                                productPrice: doc.data().productPrice, 
                                productTypeCategory: doc.data().productTypeCategory,
  
                                productRatingSum: doc.data().productRatingSum,
                                productRatingCount: doc.data().productRatingCount,

                                saleCount: doc.data().saleCount,

                                publicStatus: doc.data().publicStatus,
                                  
                              },
                          ];
  
                         
                      }
                  });
  
  
                  setBookLists([...bookLists, ...tempNewArray]);
                  const currentCursorForNextPage = querySnapshot.docs[currentLenght -1];
                  setCurrentCursor(currentCursorForNextPage);
              });
          });
      };


    return (
        <Container>
      
        <br/>
        <h3 style={{fontWeight: 'bold'}}><strong><BsSearch/>หมวดหมู่หลัก <span style={{color: 'dodgerblue'}}>{categoryName}</span></strong></h3>
        
        <br/>

        {/* <br/>
        <h4 style={{fontWeight: 'bold'}}><strong>หมวดหมู่หลัก</strong></h4><br/>
        <h3><span class="badge rounded-pill bg-light text-dark">อาญา</span> 
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>แพ่ง</span>  
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>วิอาญา</span> 
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>วิแพ่ง</span> 
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>วิอาญา</span>

        </h3>
        <br/> */}

        {/* <br/>
        <br/>
        <h4 style={{fontWeight: 'bold'}}><strong>หมวดหมู่รอง</strong></h4><br/>
        <h3><span class="badge rounded-pill bg-light text-dark">ประมวลกฎหมาย</span> 
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>พระราชบัญญัติ</span>  
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>กฎหมาย</span> 
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>หนังสือเรียน</span> 
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>เตรียมสอบ</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>เนติบัณฑิต</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>ทนายความ</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>อัยการ</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>ผู้พิพากษา</span>


        </h3> 
        <br/>
        <br/>
        <h4 style={{fontWeight: 'bold'}}><strong>หมวดหมู่ย่อย</strong></h4><br/>
        <h3><span class="badge rounded-pill bg-light text-dark">อาญา</span> 
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>แพ่ง</span>  
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>วิอาญา</span> 
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>วิแพ่ง</span> 
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>วิอาญา</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>ภาษี</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>ล้มละลาย</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>แรงงาน</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>พระธรรมนูญศาล</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>ปกครอง</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>รัฐธรรมนูญ</span>
        <span class="badge rounded-pill bg-light text-dark" style={{marginLeft: 5}}>ภาษาอังกฤษ</span>
        </h3> 
        <br/> */}

        <br/>
        

        <Row xs={2} md={4} className="sm-4">

            {bookLists.map((item) => {
                            
                return (
                               
                    <div key={item.id}>



                                <div>
                                                                    <Link to={'/ProductView/'+ item.productID} style={{textDecoration: 'none', color: "black"}}>
                                                                        <Card className="cardarticle">
                                
                                                                            {!!item.productImage ? (
                                                                                <Card.Img variant="top" class='cardarticledetailimg' style={{marginLeft: 'auto', marginRight: 'auto'}} src={item.productImage} />
                                                                            ) : (
                                                                                <Col style={{backgroundColor: '#FFFAFA'}}><div class='cardarticledetailnoimg'><strong>{(item.merchantName)}</strong></div></Col>
                                                                            )}
                                                                            
                                                                            
                                                                            <Card.Body class='cardarticledetail'>
                                                                                <Card.Title>
                                                                                </Card.Title>
                                
                                                                                <p class='articlename'><Badge bg="warning" text="dark">{item.productTypeCategory}</Badge> {item.productName}</p>
                                                                                                                           
                                                                                {/* <p class='cardarticledetailnamedatetime'>{item.merchantName} <br/> {(item.articleDate).toDate().toLocaleDateString('th-TH', {year: 'numeric', month: 'short', day: 'numeric', weekday: 'short',})} | {(item.articleDate).toDate().toLocaleTimeString()}  */}
                                                                                <p class='cardarticledetailnamedatetime'><span style={{fontSize: 10}}>{item.merchantName}</span></p>
                                                                                
                                                                                <div class='cardarticledetailnamedatetime' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: -15 }}>
                                                                                    <span style={{ fontWeight: 'bold', color: 'tomato' }}>
                                                                                        ฿{item.productPrice}
                                                                                    <span style={{ textDecoration: 'line-through', marginLeft: 5 }}>
                                                                                        ฿{item.productFullPrice}
                                                                                    </span>
                                                                                    </span>
                                                                                    <span style={{fontSize: 12}}>ขายแล้ว {item.saleCount}</span>
                                                                                </div>
                                                                             
                                                                                
                                                                                {/* <span class='cardarticledetaillikebookmark'><strong><FaRegHeart/> {item.likeCount}</strong><strong>&nbsp;&nbsp;<BsEye/> {item.viewCount + 1}</strong> <Badge style={{fontWeight: 'bold', marginTop: 5}} className="float-end rounded-pill" bg="light text-secondary">{item.articleCategory}</Badge></span></p> */}
                                   
                                                                                    
                                                                            </Card.Body>
                                                                        </Card>
                                                                    </Link> 
                                                                </div>

                                    {/* ///////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}

                    </div>

                )
            })}

            </Row>


    

            <br/>
            <br/>

        
                {currentCursor ? (
                    <Col className='text-center'>

                        <Button variant="warning rounded-pill" className="rounded-0" onClick={onMoreBooks}>แสดงเพิ่มเติม</Button>
            
                    </Col>
                ) : (
                    <Col className='text-center'>

                        <Button variant="outline-dark rounded-pill" className="rounded-0" disabled>ไม่มีหนังสือเพิ่มเติม</Button>
            
                    </Col>
                )}

            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
        
        </Container>
        
    );
};

export default Category;